import { render } from "./DimensionsSection.vue?vue&type=template&id=1fd49c7d"
import script from "./DimensionsSection.vue?vue&type=script&lang=js"
export * from "./DimensionsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__